import Manager from '../Manager';
import router from '../../../router/index';

export default function(axios) {
  axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
    if (error.response.status === 401) {
      Manager.unauthorize();
      router.push({name: 'login'});
    } else if (error.response.status === 404) {
      router.push({name: 'error'});
    } else {
      //router.push({name: 'error'});
    }
    return Promise.reject(error.response);
    });
};


// WEBPACK FOOTER //
// ./src/common/auth/interceptors/AuthorizationResponse.js